module.exports = __webpack_public_path__ + "static/media/homepage-module-2.40d5dc33.jpg";